// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollTop_button__2_6CJ","MoveUpDown":"ScrollTop_MoveUpDown__1M0Ws"};